<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t("message.Статистика_Лог_сессий") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">Log Sessions</li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper" v-if="!hasReadPermissions">
      {{ $t("message.Нет_прав_доступа_на_чтение") }}
    </div>
    <div id="main-wrapper" v-if="hasReadPermissions">
      <b-row>
        <b-col class="col-1">
          <b-form-input
            v-model="ip"
            type="text"
            placeholder="Enter IP"
          ></b-form-input>
        </b-col>
        <b-col class="col-1">
          <b-button
            :variant="'success'"
            class="mb-1 float-left"
            @click="searchLogSessions()"
            >Search</b-button
          >
        </b-col>
      </b-row>

      <b-table
        id="session_table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="id" slot-scope="row">
          {{ row.item.id }}<br />
        </template>
        <template slot="created_at" slot-scope="row">
          {{ row.item.created_at }}<br />
        </template>
        <template slot="ip_address" slot-scope="row">
          {{ row.item.ip_address }}<br />
        </template>
        <template slot="login" slot-scope="row">
          {{ row.item.login }}<br />
        </template>
        <template slot="alive" slot-scope="row">
          {{ row.item.alive }}<br />
        </template>
        <template slot="acc_type" slot-scope="row">
          {{ row.item.acc_type }}<br />
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "LogSessions",
  data() {
    return {
      isBusy: false,
      fields: [
        {
          key: "id",
          label: "Sesson ID",
          sortable: false
        },
        {
          key: "created_at",
          label: "Created at",
          sortable: false
        },
        {
          key: "ip_address",
          label: "IP address",
          sortable: false
        },
        { key: "login", label: "Login", sortable: false },
        {
          key: "alive",
          label: "Alive",
          sortable: false
        },
        {
          key: "acc_type",
          label: "Account type",
          sortable: false
        }
      ],
      perPage: 30,
      currentPage: 1,
      totalRows: 0,
      ip: ""
    };
  },
  computed: {
    hasReadPermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(
          value =>
            value == "statistics:fully_manage" ||
            value == "statistics:logsessions_fully_manage"
        ).length;
    }
  },
  methods: {
    created() {},
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      // console.log(ctx);
      let promise = this.$noname.get("logsessions", {
        params: {
          currentPage: ctx.currentPage,
          perPage: ctx.perPage,
          ip: this.ip
        }
      });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(this.$noname.HandleError);
    },
    searchLogSessions(item, index, button) {
      this.$root.$emit("bv::refresh::table", "session_table");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/LogSessions.vue